import {Component} from 'react';

/**
 * Please note: GlyphIcon are licensed to Marco Balestra,
 * who is legitimate to use them in this product he developed.
 * @desc  Any further use and/or distribution are illegal
 * @copyright GlyphIcons.com
 */
const GlyphIcon = class extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox={ this.state.viewBox ?? this.props.viewBox ?? "0 0 32 32" }
				fill={ this.state.fill ?? this.props.fill ?? "currentColor" }
				stroke={ this.state.stroke ?? this.props.stroke ?? "none" }
				style={this.state.style ?? this.props.style ?? {}}
			>
				<path d={ this.state.d ?? this.props.d ?? "" }/>
			</svg>
		);
	}
}

export default GlyphIcon;